// Function loadSourcingGuideBlock loads the sourcingGuideBlock class by dynamically importing the js on demand if needed

export function loadSourcingGuideBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-sourceing-guide-block-chunk" */ '../widgets/sourcingGuideBlock').then(wg => {

		const { SourcingGuideBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="SourcingGuideBlock"]');

		if(!$wg) {
			// console.info('SourcingGuideBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="SourcingGuideBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new SourcingGuideBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new SourcingGuideBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the SourcingGuideBlock widget');

}